import { NgModule } from '@angular/core';
import { SharedNewComponent } from './shared-new.component';
import { ChatThreadComponent } from './components/chat-thread/chat-thread.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { MainComponent } from './components/main/main.component';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { EstimateComponent } from 'projects/estimate/src/app/components/estimate-input/estimate.component';
import { EstimateOutputComponent } from 'projects/estimate/src/app/components/estimate-output/estimate-output.component';
import { DynamicLoaderDirective } from './directives/dynamic-loader.directive';
import { RunScriptsDirective } from './utils/run-scripts.directive';
import { ChatThreadNewComponent } from './components-new/chat-thread/chat-thread-new.component';
import { SideMenuNewComponent } from './components-new/side-menu-new/side-menu-new.component';
import { MainNewComponent } from './components-new/main-new/main-new.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BaseUrlInterceptor } from './interceptors/base-url.interceptor';
import { SubIdInterceptor } from './interceptors/sub-id.interceptor';
import { PromptProcessComponent } from './prompt-process/prompt-process.component';
import { DeloitteAiBannerModule } from '@shared/banner';
import { AiHubLoaderModule } from '@aihub/ui/loader';
import { DeloitteAiFooterModule } from '@shared/footer';
import { DeloitteAiHeaderModule } from '@shared/header';
import { DeloitteAiPageModule } from '@shared/page';

@NgModule({
  declarations: [
    SharedNewComponent,
    ChatThreadComponent,
    ChatThreadNewComponent,
    SideMenuComponent,
    SideMenuNewComponent,
    MainComponent,
    MainNewComponent,
    DynamicLoaderDirective,
    RunScriptsDirective,
    PromptProcessComponent,
  ],
  imports: [
    MatSelectModule,
    CommonModule,
    ReactiveFormsModule,
    EstimateComponent,
    EstimateOutputComponent,
    DeloitteAiPageModule,
    DeloitteAiHeaderModule,
    DeloitteAiFooterModule,
    AiHubLoaderModule,
    DeloitteAiBannerModule,
  ],
  exports: [SharedNewComponent, DynamicLoaderDirective, RunScriptsDirective],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseUrlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SubIdInterceptor,
      multi: true,
    },
  ],
})
export class SharedNewModule {}
